// ##############################
// // // Dashboard styles
// #############################

import { successColor } from "assets/jss/material-dashboard-react.jsx";

const dashboardStyle = {
  successText: {
    color: successColor
  },
  upArrowCardCategory: {
    width: 14,
    height: 14
  }
};

export default dashboardStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/dashboardStyle.jsx